(function () {
  'use strict';

  angular.module('unit.deal.lead').directive('unitDealLead', unitDealLead);

  unitDealLead.$inject = [];

  function unitDealLead() {
    var directive = {
      require: 'ngModel',
      bindToController: true,
      controller: 'unitDealLeadCtrl',
      controllerAs: 'vm',
      template: require('../unit.deal.lead/unit.deal.lead.html'),
      link: link,
      restrict: 'AE',
      scope: {
        unitId: '=unitId',
        model: '=ngModel',
        change: '&ngChange',
      },
    };
    return directive;

    function link(scope, element, attrs) {}
  }
})();
